import 'css-chunksrc/client/pages/zonesPage/projectsPage/exportButton/styles.scss';export default {
  "exportButton": "_exportButton_vnfhl_1",
  "text": "_text_vnfhl_17",
  "icon": "_icon_vnfhl_21"
};